export default [{
  path: '/myCouponDetail',
  name: 'myCouponDetail',
  component: () => import('@/views/my-coupons/coupon-detail/index'),
}]
